var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPerms(_vm.perms))?_c('el-popconfirm',{attrs:{"title":_vm.title,"confirm-button-text":"确 定","cancel-button-text":"取 消"},on:{"onConfirm":_vm.handleConfirm}},[_c('el-link',{attrs:{"slot":"reference","size":_vm.size,"icon":_vm.icon,"type":_vm.type},slot:"reference"})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8207720","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Confirm/DConfirmIcon.vue
// module id = null
// module chunks = 